module.exports = __webpack_public_path__ + "img/excel.635df93a.png";